/* eslint-disable prefer-template */
/* eslint-disable prefer-object-spread */
import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link as RouterLink, useNavigate } from 'react-router-dom'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { Button, Grid, Header, Message } from 'semantic-ui-react'

// material
import { styled } from '@mui/material/styles'
import { Container, Link } from '@mui/material'
import MyTextInput from '../components/common/form/MyTextInput'
import { changePasswordStart } from '../redux/auth/auth.actions'

// components
import Page from '../components/Page'
import ClientMenuLeft from './common/ClientMenuLeft'
import DisplayCognitoError from '../components/common/DisplayCognitoError'
import DisplayErrorString from '../components/common/DisplayErrorString'

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}))

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 1000,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}))

// ----------------------------------------------------------------------

export default function ClientPasswordChange() {
  const dispatch = useDispatch()

  const [passwordShown, setPasswordShown] = useState(false)

  const togglePassword = () => {
    setPasswordShown(!passwordShown)
  }
  const { currentError } = useSelector((state) => state.authReducer)
  const [errorMessage, setErrorMessage] = useState(null)
  const navigate = useNavigate()

  const initialValues = {
    oldPassword: '',
    newPassword: '',
    newPasswordCheck: '',
  }

  const validationSchema = Yup.object().shape({
    oldPassword: Yup.string().required(
      'Ancien mot de passe est un champ obligatoire',
    ),
    newPassword: Yup.string().required(
      'Nouveau mot de passe est un champ obligatoire',
    ),
    newPasswordCheck: Yup.string().required(
      'Nouveau mot de passe est un champ obligatoire',
    ),
  })

  const handleSubmit = (values, { resetForm }) => {
    if (values.newPassword !== values.newPasswordCheck) {
      setErrorMessage(
        'Le nouveau mot de passe doit être pour les deux derniers champs.',
      )
      resetForm()
      return
    }

    try {
      const payload = {
        password: values.oldPassword,
        newPassword: values.newPassword,
        navigate: navigate,
        redirectPath: '/',
      }

      dispatch(changePasswordStart(payload))
    } catch (e) {
      console.log(e.message)
    }
  }

  return (
    <RootStyle title="Register | Gestion des plaintes">
      <ClientMenuLeft />

      <Container>
        <ContentStyle>
          {' '}
          <Grid textAlign="center" verticalAlign="middle">
            <Grid.Column style={{ maxWidth: 450 }}>
              <Header as="h2" color="blue" textAlign="center">
                Changer de mot de passe
              </Header>

              <DisplayCognitoError errorMessage={currentError} />
              <DisplayErrorString errorMessage={errorMessage} />
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ isSubmitting, isValid, dirty }) => (
                  <Form className="ui form">
                    <div className="ui icon input">
                      <MyTextInput
                        name="oldPassword"
                        placeholder="Votre ancien mot de passe"
                        label="Votre ancien mot de passe"
                        type={passwordShown ? 'text' : 'password'}
                        size="60"
                      />
                      <i
                        aria-hidden="true"
                        onClick={togglePassword}
                        className="eye link icon"
                      ></i>
                    </div>
                    <div className="ui icon input">
                      <MyTextInput
                        name="newPassword"
                        placeholder="Votre nouveau mot de passe"
                        label="Votre nouveau mot de passe"
                        type={passwordShown ? 'text' : 'password'}
                        size="60"
                      />
                      <i
                        aria-hidden="true"
                        onClick={togglePassword}
                        className="eye link icon"
                      ></i>
                    </div>
                    <div className="ui icon input">
                      <MyTextInput
                        name="newPasswordCheck"
                        placeholder="Votre nouveau mot de passe"
                        label="Votre nouveau mot de passe"
                        type={passwordShown ? 'text' : 'password'}
                        size="60"
                      />
                      <i
                        aria-hidden="true"
                        onClick={togglePassword}
                        className="eye link icon"
                      ></i>
                    </div>
                    <Button
                      type="submit"
                      fluid
                      size="large"
                      color="blue"
                      content="Changer"
                    />
                  </Form>
                )}
              </Formik>
              <Message>
                <Link
                  underline="none"
                  variant="subtitle2"
                  component={RouterLink}
                  to="/"
                >
                  Retour
                </Link>
              </Message>
            </Grid.Column>
          </Grid>
        </ContentStyle>
      </Container>
    </RootStyle>
  )
}
